import { useMutation } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/data-input/upload`;

export interface UploadExcelFileRequest {
  file: File;
  scenarioId: string;
}

export interface UploadExcelFileResponse {
  columnsProcessed: number;
  message?: string;
  recordsProcessed?: number;
}

const uploadExcelFile = async (
  request: UploadExcelFileRequest
): Promise<UploadExcelFileResponse> => {
  const formData = new FormData();
  formData.append("file", request.file);
  formData.append("scenarioId", request.scenarioId);

  const response = await axios.post<UploadExcelFileResponse>(API_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

  return response.data;
};

export const useUploadExcelFile = () => {
  return useMutation<UploadExcelFileResponse, AxiosError, UploadExcelFileRequest>(
    uploadExcelFile
  );
};
